// Exports a report file to HTML template
// import { readFile, sysPath, writeFile, readDir, makeDir, unzip, checkIfExists, kill } from '../fileOps'
import { LOC_ROOT, LOC_USER_DATA } from "../../services/networkRequests";

// import {dataSource} from '../dataSource'
// import {REP_MARK, REP} from '../../shared/Data/typeDirs'
// import ReportMarker from '../../shared/Objects/reportMarker'

const isElectron = !!window.require;
let remote;

if (isElectron) {
  remote = window.require('@electron/remote');
} else {
  // Provide a mock for web version
  remote = {
    getGlobal: () => 'web' 
  };
}

const unzipDir = isElectron ? `${LOC_USER_DATA}/html_reports` : '';
const zippedReport = isElectron ? (remote.getGlobal('env') === 'dev' ? `public/dist-report.zip` : `${window.__dirname}/dist-report.zip`) : '';
// console.log('report exporting as', zippedReport)
// const path = window.require('path')
const magic = '{"magic_string":0}'

export default async function exportToHtml(data, name, realName, photoLoc, reportExistsCallback, imageMap){

  let reportDir = `${unzipDir}/${name}`
  let reportExists
  // console.log(data)
  // console.log('with global', remote.getGlobal('env'))
  console.log('imagemap', imageMap)
  let report = data.report
  let coverPageContent = data.coverPageContent
  console.log('exporting with THIS cover page content!', coverPageContent)
  let {
    coverCoverPhoto,
    coverPreparedByPhoto,
    coverPreparedForPhoto,
    coverSignature
  } = coverPageContent
  console.log('cover image IDs', coverCoverPhoto, coverPreparedByPhoto, coverPreparedForPhoto, coverSignature)
  try{
    // await makeDir(unzipDir)
    // reportExists = await checkIfExists(reportDir)
    if( reportExists ){
      // await kill(reportDir)
    }
    // await makeDir(reportDir)
    // console.log('unzip', zippedReport)
    // console.log(reportDir)
    // await unzip(zippedReport, reportDir)
    // let contents = await readDir(reportDir)
    // console.log(contents)
    let rawTarget = `${reportDir}/index.html`
    let raw //= await readFile(rawTarget)
    // identify images
    let allPics = []
    console.log('scanning report', report, coverPageContent)
    let defaultPics = [
      coverCoverPhoto,
      coverPreparedByPhoto,
      coverPreparedForPhoto,
      coverSignature
    ]
    defaultPics.forEach(pic => {
      console.log('mapping defaults', pic)
      if(!pic) return
      const base = `${pic._id}_sm.jpg`
      allPics.push({
          photoData: pic.data,
          path: `photos/${base}`,
          _id:pic._id
      })
    })
    let newForest = []
    for( let tree of report ){
      let {image, images} = tree
      let newTree = {}
      if (image) {
        let {content} = image
        if (content.length) {
          let [{_name}] = content
          console.log('loc root is %s, name is %s', LOC_ROOT, _name)
          const base = `${_name}_sm.jpg`
          if(!imageMap[_name] || (imageMap[_name] === 'undefined')) console.log('undefined miscphoto', tree)
          // image.content[0]._name = "data:image/jpg;base64, " + imageMap[_name]
          allPics.push({
            path: `photos/${base}`,
            _id:_name,
          })
        }
      }
      if( images ) {
        let {content} = images
        content = content && content[0] && content[0]._name
        let thesePics

        if( content && content.length ) {
          thesePics = []
          for( let v of content ){
            if (v.photo.includes('pagebreak')) {
              thesePics.push({
                isPagebreak: true,
                caption: v.caption,
              })
              continue
            }
            // let photo = await dataSource('remDb')[REP_MARK].getTyped({_id:v.photo})
            
            // let metaImage = await dataSource('db')[MARK].getTyped({_id:photo._metaMarker})
            // if (!metaImage._inspectionFinished) continue
            // let report = await dataSource('remDb')[REP].get({_id:photo._report})
            // if (!finsp) {
            //   console.log('FUCKED UP IMAGE', metaImage)
            // }
            if(!imageMap[v.photo] || (imageMap[v.photo] === 'undefined')) console.log('undefined photo', tree)
            console.log('process pic', v)
            // let pp = ReportMarker.getLocalPath(LOC_ROOT,name, v.photo)
            // let photoData = "data:image/jpg;base64, " + imageMap[v.photo]
            let pic = {
              path: `photos/${v.photo}.jpg`,
              caption: v.caption,
              _id:v.photo,
            }
            thesePics.push(pic)
          }
          allPics = [...allPics, ...thesePics]
        }
        newTree.formattedPics = thesePics
      }


      for (let prop in tree){
        let leaf = tree[prop]
        let content = leaf.content
        newTree[prop] = []
        if( content ){
          if( content.length ){
            // console.log('converting content to new tree', content)
            newTree[prop] = content.map(elm => {
              if( elm['!num'] ) {
                return {_name: elm._name, _mask: `${elm['!num']}: ${elm._mask}`}
              }
              let mask = elm._mask
              let name = elm._name
              if (mask && mask.includes('"')) {
                mask = mask.replace(/"/g, "''")
              }
              if (name && name.includes('"')) {
                name = name.replace(/"/g, "''")
              }
              return {_name: name, _mask: mask}
            })
          }
        }
      }
      // if(tree.recommendation.content){
      //   for(let block of tree.recommendation.content){
      //     block.icons.forEach(icon=>{
      //       console.log('exporting icon with path', icon.path)
      //     })
      //   }
      // }
      newForest.push(newTree)
    }
    console.log('made new forest', newForest)
    // move all images
    let imageDir = `${reportDir}/photos`
    // console.log('moving stuff to dir "%s"', reportDir)
    // await makeDir(imageDir, true)
    // console.log('parsing allpics', allPics)
    for( let p of allPics ){
      // if( p && p.origPath && p.path ){
      // let basename = path.basename(p.path)
      // console.log('moved %s to,', p.origPath, `${imageDir}/${basename}`)
      
      try{
        // let buff = Buffer(imageMap[p._id], 'base64')
        // await writeFile(`${imageDir}/${p._id}.jpg`, buff)
      } catch(e){
        console.warn('failed writing image',e, p, `${imageDir}/${p._id}.jpg`, imageMap)
      }
      // }
    }

    // let formatUrl = url => sysPath(`${photoLoc}/${url}`)


    // let moveCoverPhotos = async (url)=>{
    //
    //   let newCoverPhotoUrl = url.split('\\')
    //   // console.log(newCoverPhotoUrl)
    //   newCoverPhotoUrl = newCoverPhotoUrl[newCoverPhotoUrl.length-1]
    //   // console.log(newCoverPhotoUrl)
    //   newCoverPhotoUrl = sysPath(`photos/${newCoverPhotoUrl}`)
    //   // console.log(coverPageContent.coverPhotoUrl, newCoverPhotoUrl)
    //   let fileDest =  sysPath(`${reportDir}/${newCoverPhotoUrl}`)
    //   await moveFile(url, fileDest, true)
    //   return newCoverPhotoUrl
    // }

    // await moveCoverPhotos(coverPageContent.title.coverPhoto.content[0]._name)
    // await moveCoverPhotos(coverPageContent.summary.signature.content[0]._name)
    // for(let key in coverPageContent){
    //   if(key.includes('Url')) coverPageContent[key] = await moveCoverPhotos(coverPageContent[key])
    // }
    // console.log('coverPageContent before export', coverPageContent)
    report = {report: newForest, ratingsSource: {}, name: realName, coverPageContent}
    let string = JSON.stringify(report)
    string = string.replace(/\\\\/g, "/")
    string = string.replace(/'/g, "\\'")
    string = string.replace(/\n/g, "\\n")
    string = string.replace(/"/g, "\\\"")
    // console.log('string')
    // console.log(string)
    console.log('cooking this data into export', report)
    let cooked = raw.replace(magic, string)
    // await writeFile(rawTarget, cooked)
    // execModule('open-explorer', {Path: sysPath(reportDir)})
    return true

  }catch(e){
    // if(!reportExists){
    //   let filesToKill = await readDir(reportDir, true)
    //   console.log(filesToKill)
    //   filesToKill = filesToKill.data
    //   if(filesToKill){
    //     for(let i = filesToKill.length-1; i >= 0; i--) await kill(filesToKill[i])
    //   }
    //   await kill(reportDir)
    // }
    throw e
  }
}
